import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CatalogsService } from '@core/services/catalogs/catalogs.service';
import { finalize } from 'rxjs';

export interface PreviewDialogData {
  draftId: string;
}

@Component({
  selector: 'app-catalog-preview-dialog',
  templateUrl: './catalog-preview-dialog.component.html',
  styleUrls: ['./catalog-preview-dialog.component.scss'],
})
export class CatalogPreviewDialogComponent implements OnInit {
  public loading = true;
  public error = '';
  public safeHtml: SafeHtml = '';

  constructor(
    private catalogsService: CatalogsService,
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<CatalogPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PreviewDialogData,
  ) {}

  ngOnInit(): void {
    this.catalogsService
      .getPreview(this.data.draftId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (resp) => {
          this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(
            resp.html || '<p>Sin contenido</p>',
          );
        },
        error: () => {
          this.error = 'No se pudo cargar la vista previa.';
        },
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
